import ChargeHelper from 'features/Charge/chargeHelper';
import RFIDCard from 'features/Charge/ChargeRFID/components/RFIDCard';
import ChargeTransactionCompactListView from 'features/Charge/ChargeTransaction/components/ChargeTransactionCompactListView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddVehicleView from '../DialogAddVehicleView';
import AppConstants from 'general/constants/AppConstants';

ChargeVehicleDetailView.propTypes = {
  vehicleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

function ChargeVehicleDetailView({ vehicleId }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user, permissionList } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const [vehicleDetail, setVehicleDetail] = useState(null);
  useEffect(() => {
    if (vehicleId) {
      ChargeHelper.API.Vehicle.requestGetVehicleDetail(vehicleId).then((response) => {
        if (_.isObject(response)) setVehicleDetail(response);
      });
    }
  }, [vehicleId]);
  const [rfidCard, setRfidCard] = useState(null);
  useEffect(() => {
    if (vehicleDetail?.cards?.length > 0) {
      setRfidCard(vehicleDetail?.cards[0]);
    } else {
      setRfidCard(null);
    }
  }, [vehicleDetail]);

  // MARK: ---- METHODS ----
  const handleRefresh = () => {
    ChargeHelper.API.Vehicle.requestGetVehicleDetail(vehicleId).then((response) => {
      if (_.isObject(response)) setVehicleDetail(response);
    });
  };
  const handleEdit = (row) => {
    AppCustomDialogHelper.show(
      'Sửa xe',
      <DialogAddVehicleView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'lg',
      false,
      true
    );
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.Vehicle.showDialogConfirmDeleteVehicle(row, () => {
      router.navigate(-1);
    });
  };

  const buildMoreActions = (row) => {
    const actions = [];
    if (isAdmin) {
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleUpdate.code)) {
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleEdit(row);
          },
        });
      }
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleDelete.code)) {
        actions.push({
          text: 'Xóa',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleDelete(row);
          },
        });
      }
    }
    return actions;
  };

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách xe',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết xe' },
        ])}
      </div>
      <div className="row m-0 p-0 px-2 mt-4">
        {/* thong tin xe */}
        <div className="col-lg-8 mb-4 px-2">
          {UIHelper.buildCard(
            <div>
              {/* header */}
              <div className="d-flex align-items-center justify-content-between px-4 py-3">
                <div className="flex-fill">
                  <div className="d-flex align-items-center gap-3">
                    {/* avatar */}
                    <div className="">
                      {UIHelper.buildAvatar(
                        vehicleDetail?.model?.image
                          ? Utils.getFullUrl(vehicleDetail?.model?.image)
                          : null,
                        44,
                        AppResource.images.chargeConnectorTypes.vehicleDefault
                      )}
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center gap-2">
                        <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                          {vehicleDetail?.model?.name?.toUpperCase()}
                        </span>
                        <KTLabel
                          text={ChargeHelper.Utils.getVehicleStatusName(vehicleDetail?.status)}
                          isInline={true}
                          size={KTLabelSize.medium}
                          additionalClassName={`label-light-${ChargeHelper.Utils.getVehicleStatusColor(
                            vehicleDetail?.status
                          )}`}
                        />
                      </div>
                      <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                        Biển số:{' '}
                        <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                          {vehicleDetail?.plate}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3">
                  {UIHelper.buildMoreActionsButton(buildMoreActions(vehicleDetail))}
                </div>
              </div>

              <div className="row m-0 p-0 px-2">
                <div className="col-lg-6 mb-4 px-2">
                  <div>
                    {UIHelper.buildSectionCard(
                      <div>
                        {UIHelper.buildCardCellItem(
                          'Loại xe',
                          _.find(
                            ChargeHelper.Data.vehicleTypeOptions,
                            (item) => item.value === vehicleDetail?.vehicleType
                          )?.name
                        )}
                        {UIHelper.buildCardCellItem(
                          'Hãng xe',
                          vehicleDetail?.model?.brand?.name,
                          () => {
                            Utils.openInNewTab(
                              `${AppRoute.manageVehicleBrand}/${vehicleDetail?.model?.brandId}`
                            );
                          }
                        )}
                        {UIHelper.buildCardCellItem('Dòng xe', vehicleDetail?.model?.name, () => {
                          Utils.openInNewTab(
                            `${AppRoute.manageVehicleBrand}/${vehicleDetail?.model?.brandId}`
                          );
                        })}
                        {UIHelper.buildCardCellItem(
                          'Khách hàng',
                          vehicleDetail?.user?.fullname,
                          () => {
                            Utils.openInNewTab(`${AppRoute.customerDetail}/${vehicleDetail?.userId}`);
                          }
                        )}
                        {UIHelper.buildCardCellItem(
                          'Số điện thoại',
                          vehicleDetail?.user?.phone,
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 mb-4 px-2">
                  <div>
                    {UIHelper.buildSectionCard(
                      <div>
                        {UIHelper.buildCardCellItem('Biển số xe', vehicleDetail?.plate)}
                        {UIHelper.buildCardCellItem('Số khung', vehicleDetail?.vinNumber)}
                        {UIHelper.buildCardCellItem(
                          'Dung tích pin',
                          Utils.formatNumber(vehicleDetail?.model?.batteryCapacity) + ' kWh'
                        )}
                        {UIHelper.buildCardCellItem(
                          'Đầu socket',
                          vehicleDetail?.model?.connectorType?.length ? ChargeHelper?.Utils?.getChargeConnectorTypeName(vehicleDetail?.model?.connectorType) : '',
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* thong tin the RFID */}
        <div className="col-lg-4 mb-4 px-2">
          <div>
            <RFIDCard row={rfidCard} vehicle={vehicleDetail} onRefresh={handleRefresh} />
          </div>
        </div>
      </div>

      <div className="px-4">
        {/* lich su sac */}
        <div>
          <ChargeTransactionCompactListView
            title="Lịch sử sạc"
            initialFilter={{
              vehicleId: vehicleId,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ChargeVehicleDetailView;
